import { render, staticRenderFns } from "./DespesasEletronica.vue?vue&type=template&id=19fd4c3c&"
import script from "./DespesasEletronica.vue?vue&type=script&lang=js&"
export * from "./DespesasEletronica.vue?vue&type=script&lang=js&"
import style0 from "./DespesasEletronica.vue?vue&type=style&index=0&id=19fd4c3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports